import { UntypedFormControl } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { SessionService } from 'src/app/shared/services/session.service';
import { CompanyService } from '../../companies/services/company.service';
import { FilasService } from '../services/filas.service';
import { IFila, IListByFilterFilas } from '../data/lista.interface';

@Component({
  selector: 'app-filas',
  templateUrl: './filas.component.html',
  styleUrls: ['./filas.component.scss']
})
export class FilasComponent implements OnInit {
  ERoleAdminString = ERoleAdminString;
  ordenarControl = new UntypedFormControl(1);
  acaoInput = new UntypedFormControl();
  filas: IFila[] = [];
  dadosPaginacao = {
    ordenacao: EOrdenacao.AlfabeticaAZ,
    paginaSelecionada: 0,
    tamanhoPagina: 10,
    totalPaginas: 0,
    itensTotal: 0
  };

  listOrder = [
    {
      value: EOrdenacao.AlfabeticaAZ,
      label: 'Alfabética - de A a Z'
    },
    {
      value: EOrdenacao.AlfabeticaZA,
      label: 'Alfabética - de Z a A'
    },
    {
      value: EOrdenacao.MaisNovos,
      label: 'Mais novos'
    },
    {
      value: EOrdenacao.MaisAntigos,
      label: 'Mais antigos'
    }
  ];
  constructor(
    private readonly sessionService: SessionService,
    private readonly filaService: FilasService,
  ) { }

  ngOnInit(): void {
    this.carregarFilas();
    this.ordenarControl.valueChanges.subscribe((ordenacaoSelecionada: EOrdenacao) => {
      this.dadosPaginacao.ordenacao = ordenacaoSelecionada;
      this.carregarFilas();
    });
  }
  filtrarFilas(): void {
    this.carregarFilas();
  }
  limparFiltros(): void {
    this.acaoInput.reset();
    this.carregarFilas();
  }
  carregarFilas(): void {
    const filtros: IListByFilterFilas = {
      orderBy: Number(this.dadosPaginacao.ordenacao),
      pageNumber: Number(this.dadosPaginacao.paginaSelecionada),
      pageSize: Number(this.dadosPaginacao.tamanhoPagina)
    };

    const companyId = this.sessionService.getSession().companyId;
    const partnerId = this.sessionService.getSession().partnerId;
    
    if(partnerId) {
      filtros.partnerId = partnerId
    } else if (companyId) {
      filtros.companyId = companyId;
    }

    if (this.acaoInput.value) {
      filtros.searchText = String(this.acaoInput.value);
    }

    this.filaService.listarFilas(filtros).subscribe((resposta) => {
      this.filas = resposta.data;
      this.dadosPaginacao.totalPaginas = Math.ceil(resposta.count! / this.dadosPaginacao.tamanhoPagina);
      this.dadosPaginacao.itensTotal = resposta.count!;
    });
  }

  public mudouPagina(paginaSelecionada: number): void {
    this.dadosPaginacao.paginaSelecionada = paginaSelecionada;
    this.carregarFilas();
  }

  public mudouTamanhoPagina(itensPaginaSelecionada: number): void {
    this.dadosPaginacao.tamanhoPagina = itensPaginaSelecionada;
    this.carregarFilas();
  }

  public downloadExcel(): void {
    const partnerId = this.sessionService.getSession().partnerId;
    const companyId = this.sessionService.getSession().companyId;
    const accountRole = this.sessionService.getSession().accountRole;

    const filtros: IListByFilterFilas = {
      orderBy: Number(this.dadosPaginacao.ordenacao),
      pageNumber: Number(this.dadosPaginacao.paginaSelecionada),
      pageSize: Number(this.dadosPaginacao.tamanhoPagina)
    };

    if (companyId) {
      filtros.companyId = companyId;
    }

    if (this.acaoInput.value) {
      filtros.searchText = String(this.acaoInput.value);
    }
    this.filaService.exportarExcelFila(filtros);
  }
}
